export default "__VITE_ASSET__6ce2d1a2__"